import { VersionInfoComponent } from './version-info/version-info.component';
import { AccountComponent } from './account/account.component';
import { ProfileComponent } from './profile/profile.component';
import { ColumnProfilePictureComponent } from './column-profile-picture/column-profile-picture.component';
import { ComponentRegistry } from '../core/component-registry';
var UiModule = /** @class */ (function () {
    /**
     *Creates an instance of UiModule.
     */
    function UiModule() {
        ComponentRegistry.register('overlay', 'VersionInfoComponent', VersionInfoComponent);
        ComponentRegistry.register('overlay', 'AccountComponent', AccountComponent);
        ComponentRegistry.register('overlay', 'ProfileComponent', ProfileComponent);
        ColumnProfilePictureComponent.register();
    }
    return UiModule;
}());
export { UiModule };
